import { render } from "./WebRtc.vue?vue&type=template&id=573bd01f&scoped=true"
import script from "./WebRtc.vue?vue&type=script&lang=js"
export * from "./WebRtc.vue?vue&type=script&lang=js"

import "./WebRtc.vue?vue&type=style&index=0&id=573bd01f&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Mudassir\\Retrocausal\\portal_frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-573bd01f"]])

export default __exports__